import { useJournalAnalytics } from 'app/analytics/useJournalAnalytics';

import {
  JournalCardReactions,
  useCreateJournalNoteReaction,
  useDeleteJournalNoteReaction,
  JournalReaction,
  useJournalMarkNoteAsReadMutation,
} from 'features/journal';
import { User } from 'features/user/User';

type TJournalNoteCardReactions = {
  participantId: string;
  noteId: string;
  reactions: JournalReaction[];
  isNoteRead: boolean;
  user: User;
};

export const JournalNoteCardReactions = ({
  noteId,
  participantId,
  reactions,
  isNoteRead,
  user,
}: TJournalNoteCardReactions) => {
  const { mutateAsync: addReaction } = useCreateJournalNoteReaction({
    participantId,
    user,
  });
  const { mutateAsync: removeReaction } = useDeleteJournalNoteReaction({
    participantId,
  });
  const { sendNoteReactionAddedAnalyticsEvent } = useJournalAnalytics();

  const { mutateAsync: markNoteAsRead } = useJournalMarkNoteAsReadMutation({
    noteId,
    participantId,
  });

  const handleAddReaction = async (reaction: string) => {
    await addReaction({ noteId, reaction });

    sendNoteReactionAddedAnalyticsEvent();

    !isNoteRead && (await markNoteAsRead());
  };

  const handleRemoveReaction = async (reactionId: number) => {
    const isReactionTemporary = reactions.some(
      (reaction) => reaction.temporaryReactionId === reactionId
    );

    !isReactionTemporary && (await removeReaction({ noteId, reactionId }));
  };

  return (
    <JournalCardReactions
      reactions={reactions}
      onAddReaction={(reaction: string) => handleAddReaction(reaction)}
      onRemoveReaction={(reactionId: number) =>
        handleRemoveReaction(reactionId)
      }
      user={user}
    />
  );
};
